module.exports = __webpack_public_path__ + "media/images/twitter-11d778193c5048247c5907a0c50fe521.svg";